import { PBLAuthActionsProvider } from '@hendrx/core/pbl/components/PBLAuthActionsProvider';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/pbl')({
  component: PBLLayout
});

function PBLLayout() {
  return (
    <PBLAuthActionsProvider>
      <Outlet />
    </PBLAuthActionsProvider>
  );
}
